import { CandidatesTableColumns } from '../types/CandidatesTable';
import { CandidatesByCandidateBatchItem } from 'modules/analyse/types/CandidatesByCandidateBatch';
import { ConversationStatus } from 'generated-graphql/types';

export const mapCandidatesDataToTableColumns = (
  data: CandidatesByCandidateBatchItem[]
): CandidatesTableColumns[] =>
  data.map((item) => ({
    id: item.id,
    isLocked: item.isLocked ?? false,
    firstName: item.firstName,
    lastName: item.lastName,
    applicantName: `${item.firstName} ${item.lastName}`,
    isAllRequirementsMet: item.isAllRequirementsMet ?? false,
    totalScoreScaled: item.totalScoreScaled ?? null,
    analysisErrorCode: item.analysisErrorCode ?? null,
    conversationPreferredAnswersScore:
      item.conversationPreferredAnswersScore ?? null,
    conversationId: item.conversation?.id ?? null,
    conversationStatus:
      (item.conversation?.status as ConversationStatus) ?? null,
    conversationNeedsReview: item.conversation?.needsReview ?? null,
    status: item.status ?? '',
    updatedAt: item.updatedAt,
    atsCandidateId: item.atsCandidateId ?? null,
    isMessagesGenerating: item.isMessagesGenerating ?? false,
    origin: item.origin ?? null,
    atsApplicationSource: item.atsApplicationSource ?? null
  }));
